module.exports = __webpack_public_path__ + "img/r.8c467fb6.jpg";